import { Div, DivProps, Heading, P } from '@kizi/core-components';
import { Radio, RadioProps } from '@kizi/shared-components';
import React, { useMemo } from 'react';

export interface RadioWithCardProps extends RadioProps {
  title?: string;
  description?: string;
}

export interface RadioCardProps extends Omit<DivProps, 'value'> {
  name: string;
  value?: RadioProps['value'];
  radios: RadioWithCardProps[];
  containerProps?: DivProps;
}

const defaultContainerProps = {
  display: 'flex',
  alignItems: 'center',
};

export const RadioCard: React.FC<RadioCardProps> = ({
  radios,
  onChange,
  value,
  name,
  containerProps,
  ...divProps
}) => {
  const _radios = useMemo(() => {
    return radios.map((radioProps, i) => {
      const {
        title: rTitle,
        description: rDescription,
        containerProps: rContainerProps,
        ...rProps
      } = radioProps;
      const isSelected = value === radioProps.value?.toString();
      return (
        <Div
          key={'radio-' + name + '-' + i}
          display="flex"
          paddingBottom={5}
          borderBottom="1px solid"
          borderColor="second.1"
        >
          <Radio
            containerProps={{
              ...defaultContainerProps,
              ...containerProps,
              ...rContainerProps,
            }}
            {...rProps}
            name={name}
            checked={isSelected}
            onChange={(e) => {
              if (onChange) onChange(e);
            }}
          />
          <Div my={3} pl={6}>
            {rTitle && <Heading variant="H4">{rTitle}</Heading>}
            {rDescription && <P>{rDescription}</P>}
          </Div>
        </Div>
      );
    });
  }, [radios, value, name, containerProps]);

  return <Div {...divProps}>{_radios}</Div>;
};
